export default __webpack_public_path__ + "static/media/ZETON_DUZY.49aee8c8.png";